// Entrada escalonada de los bloques marcados con data-dango-aparece al entrar en pantalla.
(() => {
  if (!('IntersectionObserver' in window)) return;
  document.documentElement.classList.add('dango-js');

  const observador = new IntersectionObserver(
    (entradas) => {
      for (const entrada of entradas) {
        if (!entrada.isIntersecting) continue;
        entrada.target.classList.add('es-visible');
        observador.unobserve(entrada.target);
      }
    },
    { threshold: 0.15 }
  );

  const vigilar = (raiz) => raiz.querySelectorAll('[data-dango-aparece]').forEach((el) => observador.observe(el));
  vigilar(document);

  // En el editor del tema las secciones se recargan sueltas.
  document.addEventListener('shopify:section:load', (e) => vigilar(e.target));
})();

// Ficha de producto (escritorio): la foto mide desde el título hasta donde empiezan los
// desplegables, y no crece al abrirlos. Se recalcula al cargar, al cambiar el ancho de la ventana y al
// abrir o cerrar un desplegable (su inicio no se mueve, así que el alto no cambia).
(() => {
  const ajustar = () => {
    document.querySelectorAll('.product-information__media').forEach((media) => {
      const ficha = media.closest('.product-information');
      const detalles = ficha && ficha.querySelector('.dango-detalles');
      // Hasta que se calcula el alto la galería queda oculta (dango.css): sin esto aparecía enorme
      // y se encogía de golpe al cargar.
      media.setAttribute('data-dango-listo', '');
      if (!detalles || window.innerWidth < 750) {
        media.style.removeProperty('--dango-alto-galeria');
        return;
      }
      const desc = media.querySelector('.dango-descripcion-debajo');
      let alto;
      if (desc) {
        // Con la descripción bajo la imagen, las dos columnas acaban en la misma línea (con los desplegables
        // cerrados): la imagen ocupa lo que queda entre el título y la descripción.
        const cerrados = Array.from(detalles.querySelectorAll('summary')).reduce((t, s) => t + s.offsetHeight + 1, 1);
        const fondo = detalles.getBoundingClientRect().top + cerrados;
        alto = fondo - media.getBoundingClientRect().top - desc.offsetHeight - 24;
      } else {
        alto = detalles.getBoundingClientRect().top - media.getBoundingClientRect().top;
      }
      if (alto > 0) media.style.setProperty('--dango-alto-galeria', `${Math.round(alto)}px`);
    });
  };

  let ancho = window.innerWidth;
  window.addEventListener('resize', () => {
    if (window.innerWidth === ancho) return;
    ancho = window.innerWidth;
    ajustar();
  });
  window.addEventListener('load', ajustar);
  window.addEventListener('pageshow', ajustar);
  // Al abrir o cerrar un desplegable se vuelve a medir: el inicio de los desplegables no se mueve,
  // así que la foto se queda igual; solo sirve para recuperar el alto si el tema rehízo la ficha.
  document.addEventListener('toggle', ajustar, true);
  if (document.fonts) document.fonts.ready.then(ajustar);
  document.addEventListener('shopify:section:load', ajustar);
  ajustar();
})();

// Políticas: botón "Volver al inicio" bajo el texto. El marcado de las políticas lo genera Shopify
// y no se puede tocar desde el tema, así que se añade aquí.
(() => {
  const contenedor = document.querySelector('.shopify-policy__container');
  if (!contenedor || contenedor.querySelector('.dango-volver')) return;
  const bloque = document.createElement('div');
  bloque.className = 'dango-volver';
  const enlace = document.createElement('a');
  enlace.className = 'dango-volver__boton';
  enlace.href = '/';
  enlace.textContent = 'Volver al inicio';
  bloque.appendChild(enlace);
  contenedor.appendChild(bloque);
})();

// Filtro de precio: deslizador de dos puntas sincronizado con los campos de mínimo y máximo.
// Al soltar el punto se lanza el `change` nativo, que el tema ya escucha para filtrar.
(() => {
  const aNumero = (v) => {
    const n = parseFloat(String(v).replace(/\s/g, '').replace(',', '.'));
    return Number.isFinite(n) ? n : null;
  };

  const montar = (facet) => {
    if (facet.querySelector('.dango-precio')) return;
    const minIn = facet.querySelector('input[ref="minInput"], input[name$="price.gte"]');
    const maxIn = facet.querySelector('input[ref="maxInput"], input[name$="price.lte"]');
    if (!minIn || !maxIn) return;
    const tope = Math.ceil(aNumero(maxIn.getAttribute('data-max')) ?? 0);
    if (!tope) return;

    const caja = document.createElement('div');
    caja.className = 'dango-precio';
    caja.innerHTML =
      '<div class="dango-precio__pista"></div><div class="dango-precio__tramo"></div>' +
      `<input type="range" min="0" max="${tope}" step="1" aria-label="Precio mínimo">` +
      `<input type="range" min="0" max="${tope}" step="1" aria-label="Precio máximo">`;
    const [rMin, rMax] = caja.querySelectorAll('input');
    const tramo = caja.querySelector('.dango-precio__tramo');

    const pintar = () => {
      const a = Number(rMin.value);
      const b = Number(rMax.value);
      tramo.style.left = `${(a / tope) * 100}%`;
      tramo.style.right = `${100 - (b / tope) * 100}%`;
    };
    const desdeCampos = () => {
      rMin.value = aNumero(minIn.value) ?? 0;
      rMax.value = aNumero(maxIn.value) ?? tope;
      pintar();
    };
    const formato = (n) => String(n);

    rMin.addEventListener('input', () => {
      if (Number(rMin.value) > Number(rMax.value)) rMin.value = rMax.value;
      minIn.value = Number(rMin.value) <= 0 ? '' : formato(rMin.value);
      pintar();
    });
    rMax.addEventListener('input', () => {
      if (Number(rMax.value) < Number(rMin.value)) rMax.value = rMin.value;
      maxIn.value = Number(rMax.value) >= tope ? '' : formato(rMax.value);
      pintar();
    });
    minIn.addEventListener('change', desdeCampos);
    maxIn.addEventListener('change', desdeCampos);

    desdeCampos();
    const hueco = facet.querySelector('.facets__inputs-wrapper');
    (hueco || facet).after(caja);
  };

  const revisar = () => document.querySelectorAll('price-facet-component').forEach(montar);
  revisar();
  // El tema rehace la lista de filtros al filtrar: se vuelve a montar si desaparece.
  new MutationObserver(revisar).observe(document.body, { childList: true, subtree: true });
})();

// Cajón de filtros (móvil): el desplegable de «Ordenar» propio. El del navegador sale enorme y se
// corta por abajo; este se abre hacia arriba, con el mismo ancho que el selector y su propio scroll.
(() => {
  const montar = (envoltorio) => {
    if (envoltorio.querySelector('.dango-orden__boton')) return;
    const select = envoltorio.querySelector('select.sorting-filter__select');
    if (!select) return;

    const boton = document.createElement('button');
    boton.type = 'button';
    boton.className = 'dango-orden__boton';
    boton.setAttribute('aria-haspopup', 'listbox');
    boton.setAttribute('aria-expanded', 'false');
    boton.setAttribute('aria-label', 'Ordenar');

    // Flecha única hacia abajo (la del tema son dos flechas, arriba y abajo).
    const icono = envoltorio.querySelector(':scope > .icon-caret');
    if (icono) {
      icono.setAttribute('viewBox', '0 0 12 8');
      icono.innerHTML =
        '<path d="M1.5 1.75 6 6.25l4.5-4.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>';
    }

    const lista = document.createElement('ul');
    lista.className = 'dango-orden__lista';
    lista.setAttribute('role', 'listbox');
    lista.hidden = true;

    Array.from(select.options).forEach((op) => {
      const li = document.createElement('li');
      li.setAttribute('role', 'option');
      li.dataset.valor = op.value;
      li.textContent = op.textContent.trim();
      if (op.selected) li.setAttribute('aria-selected', 'true');
      lista.appendChild(li);
    });

    const cerrar = () => {
      lista.hidden = true;
      boton.setAttribute('aria-expanded', 'false');
      envoltorio.classList.remove('dango-orden--abierto');
    };
    boton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const abrir = lista.hidden;
      lista.hidden = !abrir;
      boton.setAttribute('aria-expanded', String(abrir));
      envoltorio.classList.toggle('dango-orden--abierto', abrir);
      if (abrir) lista.querySelector('[aria-selected="true"]')?.scrollIntoView({ block: 'nearest' });
    });
    lista.addEventListener('click', (e) => {
      const li = e.target.closest('li');
      if (!li) return;
      e.stopPropagation();
      cerrar();
      if (select.value === li.dataset.valor) return;
      select.value = li.dataset.valor;
      lista.querySelectorAll('li').forEach((x) => x.removeAttribute('aria-selected'));
      li.setAttribute('aria-selected', 'true');
      select.dispatchEvent(new Event('change', { bubbles: true }));
    });
    document.addEventListener('click', (e) => {
      if (!envoltorio.contains(e.target)) cerrar();
    });
    envoltorio.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !lista.hidden) {
        e.stopPropagation();
        cerrar();
        boton.focus();
      }
    });

    envoltorio.append(boton, lista);
  };

  const revisar = () =>
    document
      .querySelectorAll('.facets--drawer .sorting-filter__select-wrapper')
      .forEach(montar);
  revisar();
  new MutationObserver(revisar).observe(document.body, { childList: true, subtree: true });
})();

// Cajón de filtros: la franja de etiquetas reserva dos filas. Lo que no cabe se oculta y se añade
// al final de la segunda fila una etiqueta «+1», «+2»... con lo que falta.
(() => {
  let observador;

  const ajustar = (franja) => {
    franja.querySelector('.dango-mas')?.remove();
    const etiquetas = Array.from(franja.querySelectorAll('facet-remove-component'));
    etiquetas.forEach((e) => (e.style.display = ''));
    if (!etiquetas.length) return;

    const filas = () =>
      [...new Set(etiquetas.filter((e) => e.style.display !== 'none').map((e) => Math.round(e.offsetTop)))].sort(
        (a, b) => a - b
      );
    const limite = filas()[1];
    let ocultas = 0;
    if (limite !== undefined) {
      etiquetas.forEach((e) => {
        if (Math.round(e.offsetTop) > limite) {
          e.style.display = 'none';
          ocultas += 1;
        }
      });
    }
    if (!ocultas) return;

    const mas = document.createElement('span');
    mas.className = 'dango-mas';
    mas.setAttribute('aria-label', 'Más filtros seleccionados');
    franja.appendChild(mas);
    const visibles = () => etiquetas.filter((e) => e.style.display !== 'none');
    mas.textContent = `+${ocultas}`;
    // Si el «+N» cae en una tercera fila, se oculta la última etiqueta visible hasta que quepa.
    while (visibles().length > 1 && Math.round(mas.offsetTop) > limite) {
      visibles().pop().style.display = 'none';
      ocultas += 1;
      mas.textContent = `+${ocultas}`;
    }
  };

  const revisar = () => {
    document.querySelectorAll('.facets--drawer .facets__form > .facets-remove').forEach(ajustar);
    observador?.takeRecords();
  };

  let pendiente = false;
  const programar = () => {
    if (pendiente) return;
    pendiente = true;
    requestAnimationFrame(() => {
      pendiente = false;
      revisar();
    });
  };

  observador = new MutationObserver(programar);
  observador.observe(document.body, { childList: true, subtree: true });
  window.addEventListener('resize', programar);
  document.addEventListener('toggle', programar, true);
  programar();
})();

// Carruseles de producto: si todas las tarjetas caben, no hay nada que mover y se ocultan las flechas.
(() => {
  const revisar = () => {
    document.querySelectorAll('slideshow-component.resource-list__carousel').forEach((car) => {
      const slides = car.querySelector('slideshow-slides');
      if (!slides) return;
      const cabe = slides.scrollWidth <= slides.clientWidth + 1;
      car.classList.toggle('dango-sin-flechas', cabe);
    });
  };
  window.addEventListener('load', revisar);
  window.addEventListener('resize', revisar);
  window.addEventListener('pageshow', revisar);
  document.addEventListener('shopify:section:load', revisar);
  if (document.fonts) document.fonts.ready.then(revisar);
  revisar();
  setTimeout(revisar, 600);

  // Al abrir o cerrar el carrito lateral la página se estrecha sin que haya «resize» de la ventana: se vigila el propio carrusel.
  const vigilante = new ResizeObserver(revisar);
  const enlazar = () =>
    document.querySelectorAll('slideshow-component.resource-list__carousel slideshow-slides').forEach((s) => {
      if (s.dataset.vigiladoFlechas) return;
      s.dataset.vigiladoFlechas = '1';
      vigilante.observe(s);
    });
  enlazar();
  document.addEventListener('shopify:section:load', enlazar);
  window.addEventListener('load', enlazar);
  document.addEventListener('theme-drawer:open', () => setTimeout(revisar, 400));
  document.addEventListener('theme-drawer:close', () => setTimeout(revisar, 400));
})();

// Submenús de la cabecera (escritorio): el del tema es un panel ancho; se crea un desplegable sencillo con los
// mismos enlaces, justo debajo de la opción, y el del tema se oculta por CSS.
(() => {
  const montar = () => {
    document.querySelectorAll('header-menu .menu-list__list-item').forEach((li) => {
      const sub = li.querySelector(':scope > .menu-list__submenu');
      if (!sub || li.querySelector('.dango-sub')) return;
      const enlaces = Array.from(sub.querySelectorAll('a[href]'));
      if (!enlaces.length) return;
      const caja = document.createElement('div');
      caja.className = 'dango-sub';
      const lista = document.createElement('ul');
      lista.className = 'dango-sub__lista';
      const vistos = new Set();
      enlaces.forEach((a) => {
        const href = a.getAttribute('href');
        const texto = a.textContent.trim().replace(/\s+/g, ' ');
        if (!texto || vistos.has(href + texto)) return;
        vistos.add(href + texto);
        const item = document.createElement('li');
        const enlace = document.createElement('a');
        enlace.href = href;
        enlace.textContent = texto;
        item.appendChild(enlace);
        lista.appendChild(item);
      });
      caja.appendChild(lista);
      (li.querySelector('.menu-list__trigger') || li).appendChild(caja);
    });
  };
  // El desplegable arranca justo bajo el texto de la opción (no bajo toda la altura de la cabecera).
  const colocar = () => {
    document.querySelectorAll('.menu-list__trigger').forEach((t) => {
      const caja = t.querySelector('.dango-sub');
      const titulo = t.querySelector('.menu-list__link-title');
      if (!caja || !titulo) return;
      const desde = titulo.getBoundingClientRect().bottom - t.getBoundingClientRect().top;
      t.style.setProperty('--dango-sub-top', `${Math.round(desde + 4)}px`);
    });
  };
  // En una página que cuelga de un submenú (p. ej. /collections/cajas-de-sobres), la opción madre («Tienda»)
  // también se marca como activa.
  const marcarMadre = () => {
    const ruta = window.location.pathname.replace(/\/$/, '') || '/';
    document.querySelectorAll('header-menu .menu-list__list-item').forEach((li) => {
      const hijos = li.querySelectorAll('.dango-sub a');
      if (!hijos.length) return;
      const coincide = Array.from(hijos).some((a) => {
        const r = (new URL(a.href, window.location.origin).pathname || '/').replace(/\/$/, '') || '/';
        return r === ruta;
      });
      const madre = li.querySelector('a.menu-list__link');
      if (!madre) return;
      madre.classList.toggle('menu-list__link--active', coincide || madre.getAttribute('aria-current') === 'page');
      if (coincide) madre.setAttribute('aria-current', 'page');
    });
  };
  const todo = () => {
    montar();
    colocar();
    marcarMadre();
  };
  todo();
  window.addEventListener('load', todo);
  window.addEventListener('resize', colocar);
  if (document.fonts) document.fonts.ready.then(colocar);
  new MutationObserver(todo).observe(document.body, { childList: true, subtree: true });
})();

// Fila de filtros de la colección: cuando no caben todas las píldoras, el tema pone un «Más» de texto gris que abre
// el cajón de filtros. Está dentro del shadow DOM del componente, así que se estila desde aquí: píldora igual que las
// de filtro y texto «Más filtros».
(() => {
  const CSS = `
    [part='more'] .button {
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      box-sizing: border-box !important;
      width: 158px !important;
      height: 36px !important;
      padding: 0 22px !important;
      border: 1px solid #d9d0bf !important;
      border-radius: 999px !important;
      background: #ffffff !important;
      color: #1f3556 !important;
      font-family: inherit !important;
      font-size: 1rem !important;
      font-weight: 700 !important;
      white-space: nowrap !important;
      cursor: pointer !important;
      transition: transform 0.15s ease, color 0.15s ease, border-color 0.15s ease !important;
    }
    [part='more'] .button:hover,
    [part='more'] .button:focus-visible {
      transform: translateY(-2px) !important;
      border-color: #c23a0b !important;
      color: #c23a0b !important;
    }
  `;
  const aplicar = () => {
    document.querySelectorAll('.facets__overflow-list').forEach((ol) => {
      const sr = ol.shadowRoot;
      if (!sr || sr.querySelector('style[data-dango]')) return;
      const estilo = document.createElement('style');
      estilo.setAttribute('data-dango', '');
      estilo.textContent = CSS;
      sr.appendChild(estilo);
      const boton = sr.querySelector("[part='more'] .button");
      if (boton) boton.textContent = 'Más filtros';
    });
  };
  aplicar();
  window.addEventListener('load', aplicar);
  new MutationObserver(aplicar).observe(document.body, { childList: true, subtree: true });
})();

// Ficha de producto: los desplegables («Detalles del producto», «Envíos y plazos», «Devoluciones y garantía») se
// abren y se cierran poco a poco (altura y opacidad) en vez de saltar.
(() => {
  const DURACION = 420;
  const EASING = 'cubic-bezier(0.25, 0.8, 0.25, 1)';
  const reducido = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const preparar = (details) => {
    if (details.dataset.dangoAnim) return;
    details.dataset.dangoAnim = '1';
    const summary = details.querySelector(':scope > summary');
    if (!summary) return;
    let objetivo = details.open;
    let animaciones = [];

    // El aspa gira con este atributo (no con [open], que se quita al terminar de recoger): así gira a la vez que el desplegable.
    details.toggleAttribute('data-abierto', details.open);
    details.addEventListener('toggle', () => details.toggleAttribute('data-abierto', details.open));

    const contenido = () => Array.from(details.children).filter((c) => c !== summary);

    const animar = (abrir) => {
      details.toggleAttribute('data-abierto', abrir);
      animaciones.forEach((a) => a.cancel());
      const alturaInicial = details.getBoundingClientRect().height;
      if (abrir) details.open = true;
      details.style.overflow = 'hidden';
      details.style.height = 'auto';
      const alturaFinal = abrir ? details.getBoundingClientRect().height : summary.getBoundingClientRect().height;
      details.style.height = `${alturaInicial}px`;
      const alturaDe = details.animate([{ height: `${alturaInicial}px` }, { height: `${alturaFinal}px` }], {
        duration: DURACION,
        easing: EASING,
      });
      const opacidades = contenido().map((c) =>
        c.animate([{ opacity: abrir ? 0 : 1 }, { opacity: abrir ? 1 : 0 }], { duration: DURACION, easing: 'ease' })
      );
      animaciones = [alturaDe, ...opacidades];
      alturaDe.onfinish = () => {
        if (objetivo !== abrir) return;
        details.open = abrir;
        details.style.height = '';
        details.style.overflow = '';
        animaciones = [];
      };
    };

    summary.addEventListener('click', (e) => {
      if (reducido() || typeof details.animate !== 'function') return;
      e.preventDefault();
      objetivo = !objetivo;
      animar(objetivo);
    });
  };

  document.querySelectorAll('.dango-detalles__item').forEach(preparar);
})();

// Tarjetas de producto con selector de variante: la foto de la tarjeta es la de la variante elegida, al cargar y al cambiar.
// Horizon ya deja en la tarjeta las fotos de las variantes (ocultas, atributo variant-image); se muestra la que toca.
(() => {
  const mostrarFoto = (select) => {
    const mediaId = select.selectedOptions[0]?.dataset.mediaId;
    const slideshow = select.closest('product-card')?.querySelector('.card-gallery slideshow-component');
    if (!mediaId || !slideshow || typeof slideshow.select !== 'function') return;

    slideshow.querySelectorAll('slideshow-slide').forEach((slide) => {
      if (slide.getAttribute('variant-image') == null) return;
      slide.hidden = slide.getAttribute('slide-id') !== mediaId;
    });
    slideshow.select({ id: mediaId }, undefined, { animate: false });
  };

  document.addEventListener('change', (e) => {
    if (e.target instanceof HTMLSelectElement && e.target.classList.contains('dango-card-add__select')) mostrarFoto(e.target);
  });

  // Al cargar, solo si la variante por defecto no es la de la foto destacada.
  const inicial = () => {
    document.querySelectorAll('.dango-card-add__select').forEach((select) => {
      const primera = select.closest('product-card')?.querySelector('.card-gallery slideshow-slide');
      if (primera && primera.getAttribute('slide-id') !== select.selectedOptions[0]?.dataset.mediaId) mostrarFoto(select);
    });
  };
  window.addEventListener('load', () => requestAnimationFrame(inicial));
  document.addEventListener('shopify:section:load', inicial);
})();

// Logo de la cabecera: balanceo al pasar el cursor. Al salir, el ciclo en curso termina solo (vuelve al reposo)
// antes de quitar la animación, para que no haya un salto brusco.
(() => {
  const logoDe = (el) => (el instanceof Element ? el.closest('.header-section .header-logo') : null);

  document.addEventListener('mouseover', (e) => {
    const logo = logoDe(e.target);
    if (!logo) return;
    logo.dangoSalir = false;
    logo.classList.add('dango-logo-balanceo');
  });

  document.addEventListener('mouseout', (e) => {
    const logo = logoDe(e.target);
    if (!logo || logo.contains(e.relatedTarget)) return;
    const img = logo.querySelector('img');
    if (!img || !logo.classList.contains('dango-logo-balanceo')) return;
    logo.dangoSalir = true;
    img.addEventListener(
      'animationiteration',
      () => {
        if (logo.dangoSalir) logo.classList.remove('dango-logo-balanceo');
      },
      { once: true }
    );
  });
})();

// Cabecera: el desplegable de «Más» (ver dango.css) se coloca bajo el propio botón: se guarda su posición dentro de la lista.
// Además, al cerrar el carrito (que estrecha la página y manda enlaces a «Más») se obliga al menú a recomponerse, porque a
// veces se queda con los enlaces apilados hasta recargar.
(() => {
  const listas = () => document.querySelectorAll('header-menu overflow-list');

  const situar = () => {
    listas().forEach((lista) => {
      const mas = lista.querySelector('[slot="more"]');
      if (!mas) return;
      const x = mas.getBoundingClientRect().left - lista.getBoundingClientRect().left;
      lista.style.setProperty('--dango-mas-x', `${Math.round(x)}px`);
    });
  };

  // Al recuperar la página su ancho se recalcula el reparto de golpe (se deshace y se rehace en la misma pasada, sin que se vea
  // el paso intermedio), así «Más» desaparece en cuanto caben todos los enlaces.
  let plazo = null;
  const recomponer = () => {
    listas().forEach((lista) => {
      lista.setAttribute('disabled', 'true');
      lista.removeAttribute('disabled');
    });
    situar();
  };

  document.addEventListener('pointerover', (e) => e.target instanceof Element && e.target.closest('header-menu') && situar(), true);
  window.addEventListener('resize', situar);

  // La página recupera su ancho al terminar la transición del margen: ahí se recompone el menú.
  document.addEventListener(
    'transitionend',
    (e) => {
      if (e.target instanceof Element && e.target.matches('.page-wrapper') && e.propertyName === 'margin-inline-end') recomponer();
    },
    true
  );
  // Por si la transición no llega a dispararse, se recompone también poco después de cerrar.
  document.addEventListener('theme-drawer:close', () => {
    if (window.matchMedia('(min-width: 990px)').matches && !document.querySelector('theme-drawer[open]')) {
      clearTimeout(plazo);
      setTimeout(recomponer, 160);
      plazo = setTimeout(recomponer, 400);
    }
  });
})();

// Tarjetas de producto: si el título está cortado (máx. 3 líneas), se pone entero como «title» para que el navegador lo
// muestre en su tooltip nativo al pasar el ratón (discreto, sin dibujar nada en la página).
(() => {
  document.addEventListener('pointerover', (e) => {
    const tarjeta = e.target instanceof Element ? e.target.closest('product-card, .product-card') : null;
    const p = tarjeta?.querySelector("[ref='productTitleLink'] p");
    if (!p) return;
    // Un enlace invisible cubre toda la tarjeta y se lleva el ratón: el título va en la tarjeta, no en el texto.
    if (p.scrollHeight > p.clientHeight + 1) tarjeta.title = p.textContent.trim();
    else tarjeta.removeAttribute('title');
  });
})();

// Confirmación de baja del correo: Shopify no deja editar su marcado ni su texto desde el tema, así que
// se corrige aquí: texto en castellano correcto, párrafos en tarjeta y botón "Volver al inicio".
(() => {
  const contenedor = document.querySelector('.shopify-email-marketing-confirmation__container');
  if (!contenedor || contenedor.querySelector('.dango-baja__tarjeta')) return;
  const titulo = contenedor.querySelector('h1');
  const parrafos = contenedor.querySelectorAll('p');
  if (titulo) titulo.textContent = 'Te has dado de baja';
  if (parrafos[0]) parrafos[0].textContent = 'Has cancelado tu suscripción a nuestros correos. No te enviaremos más novedades.';
  if (parrafos[1]) parrafos[1].textContent = 'Si ha sido un error, puedes volver a apuntarte cuando quieras desde el formulario del pie de la web.';

  const tarjeta = document.createElement('div');
  tarjeta.className = 'dango-baja__tarjeta';
  parrafos.forEach((p) => tarjeta.appendChild(p));
  contenedor.appendChild(tarjeta);

  const bloque = document.createElement('div');
  bloque.className = 'dango-volver';
  const enlace = document.createElement('a');
  enlace.className = 'dango-volver__boton';
  enlace.href = '/';
  enlace.textContent = 'Volver al inicio';
  bloque.appendChild(enlace);
  contenedor.appendChild(bloque);
})();
